export default {
      id: "instagram-usage",
      viewBox: "0 0 31 28",
      url: __webpack_public_path__ + "svgsprite.svg#instagram",
      toString: function () {
        return this.url;
      }
    }